import React, { Component } from "react";
import { ENQUIRE_LINK } from "./utils/constants";
import { TOGGLE_LIVESTREAM } from "./utils/events";

class LiveStreamModal extends Component {
    state = {
        active: false,
        panel: null,
    };

    componentDidMount() {
        document.addEventListener(
            TOGGLE_LIVESTREAM,
            this.toggleModal.bind(this)
        );
    }

    render() {
        const { active, panel } = this.state;

        if (!active || !panel) return null;

        return (
            <div className="live-stream__wrapper gutters">
                <div className="live-stream__inner">
                    <div className="live-stream__content">
                        <div className="live-stream__popup">
                            <div className="live-stream__popup-inner">
                                <button
                                    className="close"
                                    onClick={() => this.handleClose()}
                                    title="close"
                                >
                                    <svg
                                        width="48"
                                        height="48"
                                        viewBox="0 0 48 48"
                                    >
                                        <path
                                            d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            fill="none"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                </button>

                                <div className="video-wrapper">
                                    {panel.LiveStreamImprovingCamera && (
                                        <div class="video-wrapper__cameraImproving">
                                            An improved CCTV camera solution is
                                            in progress. If you require a link
                                            to what we have, please ask your
                                            sales representative.
                                        </div> 
                                    )}
                                    <iframe
                                        width="560"
                                        height="315"
                                        src={`https://www.youtube.com/embed/${panel.youtubeLiveStreamID}?autoplay=1`}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    toggleModal(e) {
        const { panel, active } = e.data;
        this.setState({ active: true, panel });
    }

    handleClose() {
        this.setState({
            active: false,
            panel: null,
        });
    }
}

export default LiveStreamModal;
